module.exports = __webpack_public_path__ + "static/media/call-report-move-icon.8c8130f1.svg";